/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */

/**
 * @module ChaosStrategy
 */

/**
 * Strategy used for Testing Handler
 * @enum
 */
export enum ChaosStrategy {
	MANUAL,
	RANDOM,
}
